import * as React from 'react';
import { ReactElement } from 'react';
import { NavLink } from 'react-router-dom';
import { Col, Container, Row } from 'reactstrap';
import { items } from '../../../constants/content';
import { baseUrl, URLs } from '../../../constants/urls';

import ClientMastHeadContent from './client/ClientMastHeadContent';
import './MastHead.css';
// import { mastHeadItems } from './MastHeadConstant';


class MastHead extends React.Component {
  public state: any;
  constructor(props: any) {
    super(props);
    this.state = {
      hideMenu: false
    };
  }

  public render(): ReactElement {
    let filtereditems: Array<any>=[] ;
    filtereditems = items.filter((item) => item.id !== 0)
    return (
      <>
        <Container className='MastHead' fluid={true}>
          <Col xs="12">
            <Row>
              <Col xs={{ size: 10, offset: 1 }}>
                <Row>
                  <Col xs="6">
                    <span className='lbgLogo' />
                  </Col>
                  <Col xs="6">
                    {
                      this.getClientMastHeadContent("12345678", "SSA", "18th Dec 2020, 10:29")
                    }
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Container>
        {true && <Container className={'menu-container' + (this.state.hideMenu ? ' d-none-submenu' : '')} fluid={true}>
          <Col xs="12">
            <Row>
              <Col xs={{ size: 10, offset: 1 }}>
                <Row>
                  <Col xs="12">
                    <ul key="mainnav" className="nav visible" id="mainnav">
                      <li key="homeicon" className="hidden-xs home-icon" data-selector="list-item-home-icon">
                        <NavLink data-selector="cta-item-0" to={baseUrl} aria-label="home Icon" data-tealium-event="Internal Click">
                          <i className="fa fa-home" />
                        </NavLink>
                      </li>
                      
                      {filtereditems && filtereditems.map((item, index) => {
                        return <li key={index} className={item.subItems ? 'dropdown' : ''}>
                          <NavLink className='dropbtn' to={URLs.itemDetails.replace(":subItemIds", item.id.toString())} data-tealium-event="Internal Click" onClick={this.menuItemClick}>
                            {item.menuCaption || item.caption} {item.subItems && item.subItems.length>0 && item.menuCaption !== 'More >>' && <i className="fa fa-angle-down chevron" aria-hidden="true" />}
                          </NavLink>
                          {item.subItems && item.subItems.length > 0 && <div className="dropdown-content">
                            <ul>
                              {item.subItems.map((subItem: any, subIndex: number) => {
                                return <li key={index + '' + subIndex}>
                                    {subItem.subItems && subItem.subItems.length > 0 && <div className={"sub-dropdown-content" + (index>=8 ? ' left' : '')}>
                                      <ul>
                                        {subItem.subItems.map((ssItem: any, ssIndex: number) => {
                                          return <li key={index + '' + subIndex + '' + ssIndex}>
                                            {ssItem.subItems && ssItem.subItems.length > 0 && <div className={"sub-dropdown-content" + (index>=8 ? ' left' : '')}>
                                              <ul>
                                                {ssItem.subItems.map((sssItem: any, sssIndex: number) => {
                                                  return <li key={index + '' + subIndex + '' + ssIndex+ '' + sssIndex}>
                                                    <NavLink data-selector="cta-item-0" to={URLs.itemDetails.replace(":subItemIds", item.id.toString() +'-'+ subItem.id.toString() + '-' + ssItem.id.toString()+ '-' + sssItem.id.toString())} aria-label="home Icon" data-tealium-event="Internal Click"  onClick={this.menuItemClick}>
                                                      {sssItem.caption}
                                                    </NavLink>
                                                  </li>
                                                })}
                                              </ul>
                                            </div>}
                                            <NavLink data-selector="cta-item-0" to={URLs.itemDetails.replace(":subItemIds", item.id.toString() +'-'+ subItem.id.toString() + '-' + ssItem.id.toString())} aria-label="home Icon" data-tealium-event="Internal Click"  onClick={this.menuItemClick}>
                                              {ssItem.caption} {ssItem.subItems && ssItem.subItems.length >0 && <i className="fa fa-angle-right chevron" aria-hidden="true" />}
                                            </NavLink>
                                          </li>
                                        })}
                                      </ul>
                                    </div>}
                                    <NavLink data-selector="cta-item-0" to={URLs.itemDetails.replace(":subItemIds", item.id.toString() +'-'+ subItem.id.toString())} aria-label="home Icon" data-tealium-event="Internal Click"  onClick={this.menuItemClick}>
                                      {subItem.caption} {subItem.subItems && subItem.subItems.length >0 && <i className="fa fa-angle-right chevron" aria-hidden="true" />}
                                    </NavLink>
                                  </li>
                              })}
                            </ul></div>}
                        </li>
                      })}
                    </ul>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Container>}
      </>

    );

  }

  private menuItemClick = () => {
    this.setState({hideMenu: true}, ()=>{
      setTimeout(()=>{
        this.setState({hideMenu: false});
      }, 0);
    });
  }



  private getClientMastHeadContent = (clientId: string, userFirstName: string, dateTime: string): ReactElement => {
    return (
      <>
        <ClientMastHeadContent clientId={clientId}
          userFirstName={userFirstName}
          dateTime={dateTime}
        />
      </>
    );

  };

}

export default MastHead;


// WEBPACK FOOTER //
// ./src/components/shared/header/MastHead.tsx